var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MobileNav',{staticClass:"lg:hidden"}),_vm._v(" "),_c('DesktopNav',{staticClass:"hidden lg:block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }